// extracted by mini-css-extract-plugin
export default {"listContainer":"NewsList_listContainer__klMqR","header":"NewsList_header__8ykpl","list":"NewsList_list__nzePC","article":"NewsList_article__h98dx"};